import Modal from "react-modal/lib/components/Modal";
import Switch from "@mui/material/Switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";

import { useContext } from "react";
import { ContextRegisterSupplier } from "../context";
import { IndexHooks } from "./hook";
import { BtnSearch } from "../../../button/button-search";

import closeImg from "../../../../assets/close.png";
import "./style.css";

export const ModalFilterSupplier = () => {
	const { openModalFilterSupplier, isOpenModalFilterSupplier } = useContext(ContextRegisterSupplier);
	const {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		Controller,
		control,
	} = IndexHooks();

	const parameters = [
		{ id: 1, label: "Nome Fantasia", value: "nomefantasia" },
		{ id: 2, label: "Razao Social", value: "razaosocial" },
		{ id: 3, label: "Cidade", value: "cidade" },
	];

	const handleRadioOnClick = (e) => {
		setFocus("paramValue");
	};

	return (
		<Modal
			isOpen={isOpenModalFilterSupplier}
			onRequestClose={openModalFilterSupplier}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<div className="container-filter-client">
				<form action="" onSubmit={handleSubmit(handleOnSubmit)}>
					<header>
						<h2 className="title">Fornecedor</h2>
						<h6 className="text-xs border-botton mt-3 text-secondary">Pesquisar por..</h6>
						<button type="button" onClick={openModalFilterSupplier} className="react-modal-close">
							<img src={closeImg} alt="" />
						</button>
					</header>
					<div className="field-group">
						<div className="row">
							<div className=" container-radio d-flex align-items-center flex-wrap col-10">
								{parameters.map((option) => (
									<div key={option.id} className="radio col-6 col-sm-4 col-lg-4">
										<input //
											type="radio"
											id={option.id}
											// value={option.value}
											value={JSON.stringify(option)} // Serialize o objeto como uma string
											onClick={(event) => handleRadioOnClick()}
											{...register("param")}
											style={{ display: "none" }}
										/>

										<label htmlFor={option.id}>
											<span
												htmlFor={option.id}
												style={{
													marginRight: "0.5rem",
												}}
											>
												<FontAwesomeIcon
													icon={
														JSON.parse(paramSelected).value === option.value
															? faCheckSquare
															: faSquare
													}
													className="custom-checkbox"
												/>
											</span>
											{option.label}
										</label>
									</div>
								))}
							</div>
							{errors.param && <p className="errors">{errors.param.message}</p>}

							<div className="container-switch col-2 flex-wrap">
								<div className="check-input d-flex align-items-center justify-content-end">
									<Controller
										name="active"
										control={control}
										defaultValue={true}
										render={({ field }) => (
											<Switch
												checked={field.value}
												onChange={(e) => field.onChange(e.target.checked)}
												inputProps={{
													"aria-label": "Clientes Ativos",
												}}
											/>
										)}
									/>
									<label htmlFor="active">Ativo</label>
									{errors.active && <p className="errors">{errors.active.message}</p>}
								</div>
							</div>
						</div>

						<div className="input-box mt-3">
							{/* <label htmlFor="paramValue">{capitalizeFirstLetter(paramSelected)}</label> */}
							<label htmlFor="paramValue">{JSON.parse(paramSelected).label}</label>
							<input //
								id="paramValue"
								{...register("paramValue")}
								type="text"
								autoComplete="off"
								onFocus={(e) => e.target.select()}
								autoFocus
							/>
							{errors.paramValue && <p className="errors">{errors.paramValue.message}</p>}
						</div>
					</div>
					<footer>
						<BtnSearch isSubmitting={isSubmitting} />
					</footer>
				</form>
			</div>
		</Modal>
	);
};
